var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-bottom": "40px"
    }
  }, [_c('v-row', [_c('v-col', {
    staticClass: "d-none d-md-flex d-lg-flex d-xl-flex flex-column",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-timeline', {
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "align-top": ""
    }
  }, _vm._l(_vm.timelineItems, function (item, index) {
    return _c('v-timeline-item', {
      key: item.title,
      attrs: {
        "small": "",
        "color": "#000000",
        "fill-dot": "",
        "left": (index + 1) % 2 !== 0,
        "right": (index + 1) % 2 === 0
      }
    }, [_c('v-row', {
      class: {
        'row-move-right': (index + 1) % 2 !== 0,
        'row-move-left': (index + 1) % 2 === 0
      }
    }, [(index + 1) % 2 === 0 ? _c('v-col', {
      staticClass: "p-0 center-connecting-line",
      attrs: {
        "lg": "3",
        "mg": "3",
        "sm": "3",
        "cols": "4"
      }
    }, [_c('div', {
      staticClass: "connecting-line"
    })]) : _vm._e(), _c('v-col', {
      staticClass: "p-0",
      attrs: {
        "lg": "9",
        "md": "9",
        "sm": "9",
        "cols": "8"
      }
    }, [_c('div', {
      staticClass: "timeline-item-container",
      class: {
        'timeline-item-container-left': (index + 1) % 2 !== 0,
        'timeline-item-container-right': (index + 1) % 2 === 0
      },
      style: {
        width: '100%',
        height: 'auto',
        marginBottom: '0px'
      }
    }, [_c('v-chip', {
      staticClass: "chip-size",
      attrs: {
        "color": "#000000",
        "text-color": "#FFFFFF",
        "large": ""
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), !item.isVideoUnavailable ? _c('div', {
      class: {
        'timeline-item-text timeline-item-textContent-left': (index + 1) % 2 !== 0,
        'timeline-item-text timeline-item-textContent-right': (index + 1) % 2 === 0
      }
    }, [_vm._v(" " + _vm._s(item.content) + " ")]) : _vm._e(), _c('RoadmapTimelineVideo', {
      attrs: {
        "videoItem": item,
        "selectedVideoId": _vm.selectedVideoPlayingId,
        "isVideoPlayerPlayer": _vm.isVideoPlayerPlayer
      }
    })], 1)]), (index + 1) % 2 !== 0 ? _c('v-col', {
      staticClass: "p-0 center-connecting-line",
      attrs: {
        "lg": "3",
        "mg": "3",
        "sm": "3",
        "cols": "4"
      }
    }, [_c('div', {
      staticClass: "connecting-line"
    })]) : _vm._e()], 1)], 1);
  }), 1), _c('div', {
    staticClass: "w-100 flex-ctrl-container"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "color": "#424EC4"
    },
    on: {
      "click": _vm.goToLogin
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoggedIn ? 'Proceed' : 'Proceed To Login') + " ")])], 1)], 1), _c('v-col', {
    staticClass: "d-flex d-none d-sm-flex d-sm-none d-md-none d-lg-none d-xl-none flex-column align-items-center timeline-container",
    attrs: {
      "cols": "12"
    }
  }, _vm._l(_vm.timelineItems, function (item, index) {
    return _c('v-container', {
      key: item.title,
      staticClass: "timeline-mobile-item",
      attrs: {
        "fluid": ""
      }
    }, [_c('v-row', {
      staticClass: "d-flex justify-content-center"
    }, [_c('v-col', {
      staticClass: "timeline-mobile roadmap-timeline-item",
      class: {
        'timeline-mobile-left-border-blank': (index + 1) % 2 === 0,
        'timeline-mobile-right-border-blank': (index + 1) % 2 === 1,
        'timeline-mobile-last': index + 1 === _vm.timelineItems.length,
        'timeline-mobile-last-left': index + 1 === _vm.timelineItems.length && (index + 1) % 2 === 1,
        'timeline-mobile-last-right': index + 1 === _vm.timelineItems.length && (index + 1) % 2 === 0
      }
    }, [_c('v-chip', {
      staticClass: "chip-size timeline-mobile-chip",
      class: {
        'timeline-mobile-chip-left': (index + 1) % 2 === 0,
        'timeline-mobile-chip-right': (index + 1) % 2 === 1
      },
      attrs: {
        "color": "#000000",
        "text-color": "#FFFFFF",
        "large": ""
      }
    }, [_vm._v(" " + _vm._s(item.title) + " ")]), !item.isVideoUnavailable ? _c('div', {
      staticClass: "timeline-item-text my-4",
      class: {
        'timeline-item-textContent-right': (index + 1) % 2 === 0,
        'timeline-item-textContent-left': (index + 1) % 2 === 1
      }
    }, [_vm._v(" " + _vm._s(item.content) + " ")]) : _vm._e(), _c('RoadmapTimelineVideo', {
      attrs: {
        "videoItem": item,
        "selectedVideoId": _vm.selectedVideoPlayingId,
        "isVideoPlayerPlayer": _vm.isVideoPlayerPlayer,
        "containerClass": 'mb-5'
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: index + 1 === _vm.timelineItems.length,
        expression: "index + 1 === timelineItems.length"
      }],
      staticClass: "flex-mobile-button"
    }, [_c('div', {
      staticClass: "flex-fill",
      class: {
        'before-mobile-button': (index + 1) % 2 === 0
      }
    }), _c('div', {
      staticClass: "flex-ctrl-container"
    }, [_c('v-btn', {
      attrs: {
        "rounded": "",
        "large": "",
        "dark": "",
        "color": "#424EC4"
      },
      on: {
        "click": _vm.goToLogin
      }
    }, [_vm._v(" " + _vm._s(_vm.isLoggedIn ? 'Proceed' : 'Proceed To Login') + " ")])], 1), _c('div', {
      staticClass: "flex-fill",
      class: {
        'after-mobile-button': (index + 1) % 2 === 1
      }
    })])], 1)], 1)], 1);
  }), 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }